import { takeLatest, all, takeEvery } from 'redux-saga/effects';
import {
  startDiscardManualModeChanges,
  startSaveManualModeChanges,
} from './manualSaveModeDeprecated/manualSaveMode';
import {
  discardManualModeChanges,
  saveManualModeChanges,
} from './manualSaveModeDeprecated/manualSaveModeActions';
// import { syncTabSharedChanges } from './sync/sync';
import {
  syncTabChanges,
  tabSyncManualModeDiscardChanges,
} from './syncDeprecated/syncActions';
import {
  adjustNonFrozenViewportWithFreezeMi,
  calculateSheetViewportMi,
  loadSheetGroupMi,
  loadSheetMi,
} from './views/views';
import {
  adjustNonFrozenViewportWithFreezeAc,
  arrowKeyOnCell,
  calculateSheetViewport,
  cellHover,
  enterKeyOnCell,
  loadSheet,
  loadSheetGroup,
  mouseMoveWithSelection,
  openCellEditor,
  scrollViewportByButtons,
  setViewportFromScrollbarPosition,
  startCellSelection,
  startSelectionInteraction,
  stopCellSelection,
} from './views/viewsActions';
import {
  cellMouseHoverMi,
  cellSelectionMi,
  mouseMoveWithSelectionMi,
  stopCellSelectionMi,
  startSelectionInteractionMi,
} from './views/cellSelection';
import { arrowKeysMi, enterKeyMi } from './views/cellKeysInteraction';
import {
  scrollViewportByButtonsMi,
  setViewportFromScrollbarPositionMi,
} from './views/scrollbarInteraction';
// import { handleCellOperationsAc } from './cells/cellActions';
// import { handleCellOperationsMi } from './cells/cells';
import {
  syncTabChangesMi,
  tabSyncDiscardManualModeChangesMi,
} from './syncDeprecated/syncTabChanges';
import { handleSheetOperations } from './root/rootActions';
import { handleSheetOperationsSaga } from './root/root';
import { redoSheets, undoSheets } from './history/historyActions';
import { startRedoSheets, startUndoSheets } from './history/history';
import { startCreateNewSheet } from './commands/compositeCommandsActions';
import { startCreateNewSheetMi } from './commands/compositeCommands';
import { openCellEditorMi } from './views/cellEditor';

export default function* () {
  yield all([
    // takeLatest(handleGridOperationsAc, handleGridOperationsMi),
    // takeLatest(handleCellOperationsAc, handleCellOperationsMi),

    takeLatest(handleSheetOperations, handleSheetOperationsSaga),

    takeLatest(undoSheets, startUndoSheets),
    takeLatest(redoSheets, startRedoSheets),
    takeLatest(startCreateNewSheet, startCreateNewSheetMi),
    // takeLatest(addNewSheetToGroup, addNewSheetToGroupSaga),
    // takeLatest(undoSheets, undoSheetsMi),
    // takeLatest(redoSheets, redoSheetsMi),

    takeLatest(saveManualModeChanges, startSaveManualModeChanges),
    takeLatest(discardManualModeChanges, startDiscardManualModeChanges),

    // takeEvery(syncTabChanges, syncTabSharedChanges),
    takeEvery(syncTabChanges, syncTabChangesMi),
    takeEvery(
      tabSyncManualModeDiscardChanges,
      tabSyncDiscardManualModeChangesMi
    ),
    takeEvery(calculateSheetViewport, calculateSheetViewportMi),

    takeLatest(
      adjustNonFrozenViewportWithFreezeAc,
      adjustNonFrozenViewportWithFreezeMi
    ),

    takeEvery(loadSheet, loadSheetMi),
    takeEvery(loadSheetGroup, loadSheetGroupMi),

    takeLatest(startCellSelection, cellSelectionMi),
    takeLatest(cellHover, cellMouseHoverMi),
    takeLatest(stopCellSelection, stopCellSelectionMi),
    takeLatest(mouseMoveWithSelection, mouseMoveWithSelectionMi),

    takeLatest(enterKeyOnCell, enterKeyMi),
    takeLatest(arrowKeyOnCell, arrowKeysMi),

    takeLatest(openCellEditor, openCellEditorMi),

    takeLatest(startSelectionInteraction, startSelectionInteractionMi),

    takeEvery(scrollViewportByButtons, scrollViewportByButtonsMi),

    takeLatest(
      // 100,
      setViewportFromScrollbarPosition,
      setViewportFromScrollbarPositionMi
    ),
  ]);
}
